import {IsString} from 'class-validator';

export class SaveUserTemplateDto {
  @IsString()
  title!: string;

  @IsString()
  message!: string;
}
